import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".fallback-module_fallbackWrapper__sqsIU {\n  padding: 20px;\n  text-align: center;\n}";
var styles = {"fallbackWrapper":"fallback-module_fallbackWrapper__sqsIU"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=fallback.module.scss.js.map
